import { ComponentProps } from 'react';
import { Platform, Pressable, StyleSheet, TouchableOpacity } from 'react-native';
import { IconButton, colors, spacing, usePressable } from '@pletly/ui';

import { UserInfo } from '%components';
import TrashIconWithBg from '%assets/icons/delete.svg';
import TrashIcon from '%assets/icons/trash.svg';

type FriendProps = Omit<ComponentProps<typeof UserInfo>, 'username'> & {
	username: string;
	onDelete?: () => void;
};

export const Friend = ({
	id,
	username,
	email,
	photoUrl,
	onDelete,
	onPress,
	...userInfoProps
}: FriendProps) => {
	const { isHovered, onHoverIn, onHoverOut } = usePressable();

	return (
		<Pressable
			style={[styles.friend, isHovered && styles.hovered]}
			onHoverIn={onHoverIn}
			onHoverOut={onHoverOut}
		>
			<UserInfo
				bolded
				id={id}
				name={username}
				email={email}
				photoUrl={photoUrl}
				onPress={onPress}
				{...userInfoProps}
			/>
			<DeleteButton onDelete={onDelete} />
		</Pressable>
	);
};

const DeleteButton = ({ onDelete }: { onDelete: FriendProps['onDelete'] }) => {
	if (!onDelete) {
		return null;
	}

	return Platform.select({
		web: <IconButton Icon={TrashIcon} size="small" appearance="ghost" onPress={onDelete} />,
		default: (
			<TouchableOpacity onPress={onDelete}>
				<TrashIconWithBg />
			</TouchableOpacity>
		),
	});
};

const styles = StyleSheet.create({
	friend: {
		flex: 1,
		flexDirection: 'row',
		paddingVertical: spacing(2),
		paddingHorizontal: spacing(2),
		alignItems: 'center',
	},
	hovered: {
		backgroundColor: colors.neutral300,
	},
});
